import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function isRegisteredUser(params) {
    const { baseUrl, brandId, country, logonId, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of isRegisteredUser()');
    invariant(brandId, 'brandId is a required param of isRegisteredUser()');
    invariant(country, 'country is a required param of isRegisteredUser()');
    invariant(logonId, 'logonId is a required param of isRegisteredUser()');
    invariant(clientId, 'clientId is a required param of isRegisteredUser()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/loginidentity/${logonId}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'HEAD' }), undefined, clientId, clientSecret),
        'isRegisteredUser',
    );
}
